export const FieldButton = ({data, onClick}) => {
    return (
        <button className="field-select-button" onClick={onClick}>
            <img src={data?.background} alt="" className="sm-rnd-img" />
            <span className="field-title">
                {data.caption}
            </span>
        </button>
    )
}